/**
 * File: peerReviewEvents.ts
 * Description: Lightweight cross-component sync for the peer-review checklist.
 *   Keep/Undo and fixes can be triggered from either the checklist tab
 *   (PeerReviewTable) or the Full Document tab (ReviewDetailPage); dispatching
 *   this event lets the other view re-fetch so both stay in sync.
 */

export const PEER_REVIEW_CHANGED_EVENT = 'peerReviewChanged';

/** Notify other peer-review views that the checklist/document changed. */
export const notifyPeerReviewChanged = (): void => {
  if (globalThis.window !== undefined) {
    globalThis.dispatchEvent(new CustomEvent(PEER_REVIEW_CHANGED_EVENT));
  }
};
